/**
 * Import Dependency
 */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import { injectIntl } from 'react-intl'
import * as getMenusAction from '../../actions/components/menu'
import * as getCategoriesAction from '../../actions/components/category'
import * as basketAction from '../../actions/components/basket'
import * as navbarActions from '../../actions/components/navbar'
import * as categoryDetailListActions from '../../actions/components/categorydetaillist'
import menu from '../../services/api/menu'

import CategoryDetailList from '../../components/CategoryDetailList'
const mapStateToProps = (state, ownProps) => {
  const { match } = ownProps // > match object from react router.
  const params = match.params // > params.id is category id.
  const key = menu.getListKey(params.id, params.tag)
  return {
    user: state.user,
    merchant: state.merchant,
    form: state.form,
    menus: state.menusCache[key],
    commodities: state.commodities,
    tags: state.tags,
    selectedTag: state.selectedTag,
    categories: state.categories,
    selectedCategory: state.selectedCategory,
    selectedSetCategory: state.selectedSetCategory,
    isTakeaway: state.basket.isTakeaway,
    isStoreDelivery: state.basket.isStoreDelivery,
    orders: state.orders,
    activeSetStep: state.setStep.current,
    isSearchMode: state.isSearchMode,
    menusCache: state.menusCache,
    query: state.query,
  }
}
const mapDispatchToProps = (dispatch) => {
  const { getMenus, getTags, selectTag } = bindActionCreators(getMenusAction, dispatch)
  const { getCategories } = bindActionCreators(getCategoriesAction, dispatch)
  const { resetStash } = bindActionCreators(basketAction, dispatch)
  const { isStickyNavbarSwiper } = bindActionCreators(navbarActions, dispatch)
  const { updateSetStep, updateSearchModeDisplay } = bindActionCreators(categoryDetailListActions, dispatch)

  return {
    getMenus,
    getCategories,
    getTags,
    selectTag,
    resetStash,
    isStickyNavbarSwiper,
    updateSetStep,
    updateSearchModeDisplay,
  }
}

/**
 * Export
 */
export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(CategoryDetailList)))



// WEBPACK FOOTER //
// ./src/containers/components/CategoryDetailList.js